import React from 'react';

type CindroBrandProps = {
  compact?: boolean;
};

function CindroBrand({ compact = false }: CindroBrandProps) {
  return (
    <div className={`cindroBrand${compact ? ' is-compact' : ''}`} aria-label="Cindro">
      <span className="cindroSigil" aria-hidden="true">
        <span />
      </span>
      <span className="cindroBrandCopy">
        <strong>Cindro</strong>
        {!compact ? <small>Release control</small> : null}
      </span>
    </div>
  );
}

export { CindroBrand };
